define(function (require) {
    var $ = require("jquery");
    var dataLayerService = require("@modules/services/dataLayerService");

    // container for a newsletter listing item: newsletter-item, link for newsletterViewed gtm-newsletter-newsletterViewed

    var $newsletterItems = $(".newsletter-item");
    var pageTitle = document.title;

    $newsletterItems.each(function (index, value) {
        var $newsletterItem = $(value);

        var $issueNumber = $newsletterItem.find(".gtm-newsletter-issueNumber");
        var $issueDate = $newsletterItem.find(".gtm-newsletter-issueDate");

        $newsletterItem.find("a.gtm-newsletter-newsletterViewed").on("click", function () {
            dataLayerService.pushEventToGtmDataLayer({
                event: "newsletterViewed",
                eventCategory: "Newletters | ",
                eventAction: "click from " + pageTitle,
                eventLabel: $issueNumber.text() + " - " + $issueDate.text()
            });
        });
    });
});
